import { Formik } from "formik";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Eye, Loader2 } from "lucide-react";
import { EyeClosedIcon } from "@radix-ui/react-icons";
import { PhoneInput } from "../../components/ui/phone-input";
import { API, fileUpload, IV, SECRETKEY } from "../../config";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Spin from "../../components/Spin";
import AuthLeftSide from "../../components/AuthLeftSide";
import { formatName } from "../../lib/Misc";
import { useAllOrganizationTypes, useStateList } from "./SignUpHelper";
import CustomLabelText from "../../components/CustomLabelText";
import SearchSelect from "../../components/SearchSelect";
import PostalCodeInput from "../../components/PostalCodeInput";
import { ThemeToggle } from "../../components/ThemeToggle";
import ReactInputMask from "react-input-mask";
import { cn } from "../../lib/utils";
import { SuburbList } from "../../lib/OptionsAPI";
import SuburbSelect from "../../components/SuburbSelect";
import { useUserCountry } from "../../components/useUserCountry";
import { FirmSignupSchema } from "../../lib/Validation";
import LogoSVG from "../../components/LogoSVG";
import FaviconSVG from "../../components/FaviconSVG";
import { Checkbox } from "../../components/ui/checkbox";

const SignUp = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [agreeCheck, setAgreeCheck] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const [activeTab, setActiveTab] = useState();

  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const EmailVerification = localStorage.getItem("EmailVerification");
  const hasToken = localStorage.getItem("ts-auth-token");
  const clientId = localStorage.getItem("clientId");
  const [loading, setLoading] = useState(false);
  const defaultEmail = localStorage.getItem("invite-accountingFirmEmail");

  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const signUpEmail = query.get("email");

  const [suburbLoading, setSuburbLoading] = useState(false);
  const [suburbListing, setSuburbListing] = useState([]);
  const [suburbList, setSuburbList] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const { stateLoading, stateList = [] } = useStateList();
  const stateArray = stateList?.map((item) => {
    const { id: value, name, short_name, ...rest } = item;
    return { label: name + ` (${short_name})`, value, ...rest };
  });

  const { allOrganizationTypeLoading, allOrganizationType = [] } =
    useAllOrganizationTypes({ amlCTFType: false });
  const organizationType = allOrganizationType?.map((item) => {
    const { id: value, name, short_name, ...rest } = item;
    return { label: name, value, ...rest };
  });

  const FetchSuburbList = async (state_id) => {
    await SuburbList(state_id, 1, setSuburbLoading, setSuburbList, true);
  };

  useEffect(() => {
    if (suburbList) {
      let suburbTempListing = suburbList?.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      }));
      setSuburbListing(suburbTempListing || []);
    } else {
      setSuburbListing([]);
    }
  }, [suburbList]);

  var CryptoJS = require("crypto-js");

  const iv = IV;
  const key = SECRETKEY;

  const fkey = CryptoJS.enc.Utf8.parse(key);
  const fiv = CryptoJS.enc.Utf8.parse(iv);

  const handleFormSubmit = async (value, { resetForm }) => {
    const formData = new FormData();

    value.phone = value?.phone ? `${value?.phone}`.replace(/ /g, "") : "";
    value.abn = value?.abn ? `${value?.abn}`.replace(/ /g, "") : "";

    let state_id = value?.state_id ? value?.state_id : "";
    let suburb_id = value?.suburb_id ? value?.suburb_id : "";

    const encPassword = CryptoJS.AES.encrypt(value?.password, fkey, {
      iv: fiv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    const finalEncryptedPassword = encPassword.ciphertext.toString(
      CryptoJS.enc.Base64
    );

    const encConfirmPassword = CryptoJS.AES.encrypt(
      value?.password_confirmation,
      fkey,
      {
        iv: fiv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    const finalEncryptedConfirmPassword =
      encConfirmPassword.ciphertext.toString(CryptoJS.enc.Base64);

    formData.append("first_name", value?.first_name ? value?.first_name : "");
    formData.append("last_name", value?.last_name ? value?.last_name : "");
    formData.append("phone", value?.phone ? value?.phone : "");
    formData.append("email", value?.email ? value?.email : "");
    formData.append(
      "password",
      finalEncryptedPassword ? finalEncryptedPassword : ""
    );
    formData.append(
      "password_confirmation",
      finalEncryptedConfirmPassword ? finalEncryptedConfirmPassword : ""
    );
    formData.append("abn", value?.abn ? value?.abn : "");
    formData.append(
      "license_number",
      value?.license_number ? value?.license_number : ""
    );
    formData.append("organization_type_id", value?.type);
    formData.append(
      "business_name",
      value?.business_name ? value?.business_name : ""
    );
    formData.append(
      "business_email",
      value?.business_email ? value?.business_email : ""
    );
    formData.append("street", value?.street ? value?.street : "");
    formData.append("state_id", state_id ? state_id : "");
    formData.append("suburb_id", suburb_id ? suburb_id : "");
    formData.append(
      "postal_code",
      value?.postal_code ? value?.postal_code : ""
    );

    try {
      setLoading(true);
      const { data } = await fileUpload(API.FIRM_SIGNUP, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setLoading(false);
      if (data?.status === 200 && data?.message) {
        resetForm();
        localStorage.setItem(
          "FullName",
          formatName(data?.data?.first_name, data?.data?.last_name)
        );
        localStorage.setItem(
          "ts-auth-email",
          data?.data?.email ? data?.data?.email : ""
        );

        localStorage.setItem("userId", data?.data?.id ? data?.data?.id : "");

        navigate("/");
        // navigate(`/subscription`);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    EmailVerification &&
      userId &&
      hasToken &&
      // (clientId ? navigate("/businesses") : navigate("/clients"));
      navigate("/trusts");
  }, [EmailVerification, userId, clientId, hasToken, navigate]);

  useEffect(() => {
    navigate(`/signup`);
  }, [navigate, signUpEmail]);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const toggleShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const country = useUserCountry();
  console.log(country);

  return (
    <div className="w-full lg:grid lg:grid-cols-3 min-h-screen">
      {(loading || stateLoading) && <Spin full={true} />}
      <AuthLeftSide />
      <div className="flex lg:flex-row flex-col items-center justify-center col-span-2 lg:h-auto md:h-screen sm:h-[calc(100vh_+_160px)] sm:mt-0 mt-16  sm:p-6 p-4 py-8">
        <LogoSVG className="lg:hidden absolute top-[2%] !text-webPrimary !fill-webPrimary h-20 w-full" />
        <div className="mx-auto grid md:w-[786px] w-full gap-6 lg:mt-0 sm:mt-40">
          <div className="grid gap-2 text-center">
            <h1 className="text-3xl font-bold">Sign Up</h1>
            <p className="text-balance text-muted-foreground">
              Enter your details below to sign up
            </p>
          </div>
          <Formik
            initialValues={{
              first_name: "",
              last_name: "",
              phone: "+61",
              email: "",
              password: "",
              password_confirmation: "",
              business_name: "",
              business_email: defaultEmail ? defaultEmail : "",
              type: "",
              abn: "",
              license_number: "",
              street: "",
              state_id: "",
              suburb_id: "",
              postal_code: "",
            }}
            validationSchema={FirmSignupSchema}
            validateOnBlur={false}
            validateOnChange={true}
            onSubmit={handleFormSubmit}
          >
            {({
              values,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => (
              <form
                onSubmit={handleSubmit}
                className="row needs-validation flex flex-col gap-4"
                noValidate
                autoComplete="off"
              >
                <Card>
                  <CardHeader className="p-4">
                    <CardTitle className="text-md">User Details</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="grid gap-4">
                      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
                        <div className="grid gap-2">
                          <Label htmlFor="first_name">
                            <CustomLabelText
                              required={true}
                              labelText="First name"
                              errorField={errors?.first_name}
                            />
                          </Label>
                          <Input
                            id="first_name"
                            placeholder="Enter First Name"
                            required
                            name="first_name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.first_name}
                            autoFocus={true}
                            className={
                              errors?.first_name &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                          />
                        </div>
                        <div className="grid gap-2">
                          <Label htmlFor="last_name">
                            <CustomLabelText
                              required={true}
                              labelText="Last name"
                              errorField={errors?.last_name}
                            />
                          </Label>
                          <Input
                            id="last_name"
                            placeholder="Enter Last Name"
                            required
                            name="last_name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.last_name}
                            className={
                              errors?.last_name &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                          />
                        </div>

                        <div className="grid gap-2">
                          <Label htmlFor="phone">
                            <CustomLabelText
                              required={true}
                              labelText="Phone"
                              errorField={errors?.phone}
                            />
                          </Label>
                          <PhoneInput
                            onChange={(e) => {
                              setFieldValue("phone", e);
                            }}
                            value={values?.phone}
                            defaultValue={"+61"}
                            defaultCountry={"AU"}
                            minLength={15}
                            maxLength={15}
                            onBlur={handleBlur}
                            className={
                              errors?.phone &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                          />
                        </div>
                        <div className="grid gap-2">
                          <Label htmlFor="email">
                            <CustomLabelText
                              required={true}
                              labelText="Email"
                              errorField={errors?.email}
                            />
                          </Label>
                          <Input
                            id="email"
                            type="email"
                            placeholder="m@example.com"
                            required
                            autoComplete="off"
                            name="email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.email}
                            className={
                              errors?.email &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                          />
                        </div>

                        <div className="grid gap-2">
                          <Label htmlFor="password">
                            <CustomLabelText
                              required={true}
                              labelText="Password"
                              errorField={errors?.password}
                            />
                          </Label>
                          <div className="relative">
                            <Input
                              id="password"
                              type={showPassword ? "text" : "password"}
                              name="password"
                              autoComplete="off"
                              placeholder="Enter Password"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.password}
                              className={
                                errors?.password &&
                                `focus-visible:ring-red-500 border-red-500`
                              }
                            />

                            {showPassword ? (
                              <span className="absolute top-2 right-2">
                                <Eye
                                  width={20}
                                  height={20}
                                  onClick={toggleShowPassword}
                                />
                              </span>
                            ) : (
                              <span className="absolute top-2 right-2">
                                <EyeClosedIcon
                                  width={20}
                                  height={20}
                                  onClick={toggleShowPassword}
                                />
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="grid gap-2">
                          <Label htmlFor="password_confirmation">
                            <CustomLabelText
                              required={true}
                              labelText="Confirm Password"
                              errorField={errors?.password_confirmation}
                            />
                          </Label>
                          <div className="relative">
                            <Input
                              autoComplete="off"
                              id="password_confirmation"
                              type={showConfirmPassword ? "text" : "password"}
                              name="password_confirmation"
                              placeholder="Enter Confirm Password"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.password_confirmation}
                              className={
                                errors?.password_confirmation &&
                                `focus-visible:ring-red-500 border-red-500`
                              }
                            />

                            {showConfirmPassword ? (
                              <span className="absolute top-2 right-2">
                                <Eye
                                  width={20}
                                  height={20}
                                  onClick={toggleShowConfirmPassword}
                                />
                              </span>
                            ) : (
                              <span className="absolute top-2 right-2">
                                <EyeClosedIcon
                                  width={20}
                                  height={20}
                                  onClick={toggleShowConfirmPassword}
                                />
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
                <Card>
                  <CardHeader className="p-4">
                    <CardTitle className="text-md">Business Details</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="grid gap-4">
                      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
                        <div className="grid gap-2">
                          <Label htmlFor="business_name">
                            <CustomLabelText
                              required={true}
                              labelText="Business Name"
                              errorField={errors?.business_name}
                            />
                          </Label>
                          <Input
                            id="business_name"
                            placeholder="Enter Business Name"
                            required
                            name="business_name"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.business_name}
                            className={
                              errors?.business_name &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                          />
                        </div>
                        <div className="grid gap-2">
                          <Label htmlFor="business_email">
                            <CustomLabelText
                              required={true}
                              labelText="Business Email"
                              errorField={errors?.business_email}
                            />
                          </Label>
                          <Input
                            id="business_email"
                            type="email"
                            placeholder="m@example.com"
                            required
                            autoComplete="off"
                            name="business_email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.business_email}
                            className={
                              errors?.business_email &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                          />
                        </div>

                        <div className="grid gap-2">
                          <Label htmlFor="street">
                            <CustomLabelText
                              required={true}
                              labelText="Street Address"
                              errorField={errors?.street}
                            />
                          </Label>
                          <Input
                            id="street"
                            placeholder="Enter Street"
                            required
                            name="street"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.street}
                            className={
                              errors?.street &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                          />
                        </div>
                        <div className="grid gap-2">
                          <Label htmlFor="state_id">
                            <CustomLabelText
                              required={true}
                              labelText="State"
                              errorField={errors?.state_id}
                            />
                          </Label>
                          <SearchSelect
                            frameworks={stateArray}
                            optionType={"State"}
                            clearable={true}
                            onClear={() => {
                              setFieldValue("state_id", "");
                              setFieldValue("suburb_id", "");
                              setSuburbList([]);
                            }}
                            handleSelect={(e) => {
                              setFieldValue("state_id", e);
                              setFieldValue("suburb_id", "");
                              setSuburbList([]);
                              FetchSuburbList(e);
                            }}
                            handleBlur={handleBlur}
                            className={
                              errors?.state_id &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                            disabled={false}
                          />
                        </div>

                        <div className="grid gap-2">
                          <Label htmlFor="suburb_id">
                            <CustomLabelText
                              required={true}
                              labelText="Suburb"
                              errorField={errors?.suburb_id}
                            />
                          </Label>
                          <div className="relative">
                            <SuburbSelect
                              state_id={values?.state_id} // Pass the selected state ID
                              frameworkData={suburbListing} // List of suburbs
                              loading={suburbLoading}
                              onClear={() => {
                                setFieldValue("suburb_id", "");
                              }}
                              optionType="Suburb"
                              handleSelect={(e) => {
                                setFieldValue("suburb_id", e);
                              }}
                              name="suburb_id"
                              handleBlur={handleBlur}
                              className={
                                errors?.suburb_id &&
                                `focus-visible:ring-red-500 border-red-500`
                              }
                              disabled={values?.state_id ? false : true}
                              initialValue={values?.suburb_id}
                              setSuburbList={setSuburbList} // Update suburb list as new data loads
                              setSuburbLoading={setSuburbLoading} // Control loading state
                            />
                            {suburbLoading && (
                              <span className="absolute top-2 right-2 animate-spin">
                                <Loader2 width={20} height={20} />
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="grid gap-2">
                          <Label htmlFor="postal_code">
                            <CustomLabelText
                              required={true}
                              labelText="Postal Code"
                              errorField={errors?.postal_code}
                            />
                          </Label>
                          <PostalCodeInput
                            id="postal_code"
                            placeholder="Enter Postal Code"
                            required={true}
                            name="postal_code"
                            handleChange={(e) => {
                              setFieldValue("postal_code", e);
                            }}
                            handleBlur={handleBlur}
                            className="justify-start"
                            inputClassName={
                              errors?.postal_code &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                            value={
                              values?.postal_code ? values?.postal_code : ""
                            }
                          />
                        </div>

                        <div className="grid gap-2">
                          <Label htmlFor="type">
                            <CustomLabelText
                              required={true}
                              labelText="Industry Type"
                              errorField={errors?.type}
                            />
                          </Label>
                          <div className="relative">
                            <SearchSelect
                              frameworks={organizationType}
                              optionType={"Industry Type"}
                              handleSelect={(e) => {
                                setFieldValue("type", e);
                              }}
                              handleBlur={handleBlur}
                              className={
                                errors?.type &&
                                `focus-visible:ring-red-500 border-red-500`
                              }
                              disabled={false}
                            />
                            {allOrganizationTypeLoading && (
                              <span className="absolute top-2 right-2 animate-spin">
                                <Loader2
                                  width={20}
                                  height={20}
                                  onClick={toggleShowPassword}
                                />
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="grid gap-2">
                          <Label htmlFor="abn">
                            <CustomLabelText
                              required={false}
                              labelText="ABN"
                              errorField={errors?.abn}
                            />
                          </Label>
                          <ReactInputMask
                            id="abn"
                            type="text"
                            name="abn"
                            value={values?.abn ? values?.abn : ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            mask="99 999 999 999"
                            maskChar={null}
                            autoComplete="off"
                            onKeyPress={(e) => {
                              e.which === 13 && e.preventDefault();
                            }}
                            className={
                              errors?.abn
                                ? `${cn(
                                    "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                                  )} focus-visible:ring-red-500 border-red-500`
                                : cn(
                                    "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
                                  )
                            }
                          />
                        </div>
                        <div className="grid gap-2">
                          <Label htmlFor="license_number">
                            <CustomLabelText
                              labelText="Unique ID/REBA/Licence No."
                              errorField={errors?.license_number}
                            />
                          </Label>
                          <Input
                            id="license_number"
                            placeholder=""
                            required
                            name="license_number"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values?.license_number}
                            className={
                              errors?.license_number &&
                              `focus-visible:ring-red-500 border-red-500`
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
                <div className="w-full flex items-center justify-center space-x-4">
                  <Checkbox
                    id="terms"
                    checked={agreeCheck}
                    name="same_address"
                    onClick={() => {
                      setAgreeCheck(!agreeCheck);
                    }}
                  />
                  <label
                    htmlFor="terms"
                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                  >
                    I agree to the{" "}
                    <Link
                      to="https://trustsoft.com.au/terms-conditions/"
                      className="underline"
                      target="_blank"
                    >
                      Terms & Condition
                    </Link>
                  </label>
                </div>
                <div className="w-full flex items-center justify-center">
                  <Button
                    type="submit"
                    className="w-fit"
                    disabled={!agreeCheck}
                  >
                    Create an account
                  </Button>
                </div>
                <div className="text-center text-sm">
                  Already have an account?{" "}
                  <Link to="/" className="underline">
                    Sign in
                  </Link>
                </div>
                <div className="text-center text-sm">
                  If you face any difficulties in the signup process. please
                  contact our{" "}
                  <Link
                    to="https://trustsoft.com.au/contact-us/"
                    className="underline"
                    target="_blank"
                  >
                    support team
                  </Link>
                </div>
              </form>
            )}
          </Formik>
          <p className="lg:hidden p-4 text-xs flex items-start gap-1 text-justify">
            <FaviconSVG className="h-5 w-5 !text-webPrimary !fill-webPrimary" />
            <span className="flex-1">
              TrustSoft acknowledges the Traditional Custodians of country
              throughout Australia and their connections to land, sea and
              community. We pay our respect to their Elders past and present and
              extend that respect to all Aboriginal and Torres Strait Islander
              peoples today.
            </span>
          </p>
        </div>
      </div>
      <div className="fixed top-4 right-4">
        <ThemeToggle />
      </div>
    </div>
  );
};

export default SignUp;
